import { object, string, union, literal, z, nativeEnum } from "zod";

import { EVENT_CODES } from "@/constants/eventCodes";

export const PayVideoResponseDTOError = object({
  requestDTO: object({
    dataMap: object({
      error: string(),
      eventCode: nativeEnum(EVENT_CODES).optional(),
    }),
  }),
});

export const VideoSchema = z.object({
  id: z.number(),
  ladyId: z.number(),
  fileName: z.string().optional(),
  fileNameUrl: z.string().url().optional(),
  gif: z.string().url().optional(),
  isFavorite: z.boolean().optional(),
  isPaid: z.boolean().optional(),
  removedByLady: z.boolean(),
  source: z.string().url().optional(),
  thumbnailName: z.string().optional(),
  thumbnailNameGif: z.string().url().optional(),
  thumbnailNameStatic: z.string().url().optional(),
  type: z.literal("video"),
  videoType: z.enum(["ORDINAL"]),
  viewsCount: z.number().optional(),
});

export const PayVideoResponseDTOSuccess = object({
  requestDTO: object({
    processorClass: literal("PayVideo"),
    dataMap: object({
      result: VideoSchema.optional(),
      actualDate: string(),
    }),
  }),
});

export const errorDto = (response: PayVideoResponseDTO) =>
  PayVideoResponseDTOError.safeParse(response);

export const isSuccessDto = (
  data: PayVideoResponseDTO,
): data is PayVideoResponseDTO => {
  return PayVideoResponseDTOSuccess.safeParse(data).success;
};

export type PayVideoResponseDTOSuccess = z.infer<
  typeof PayVideoResponseDTOSuccess
>;

export type PayVideoResponseDTOError = z.infer<typeof PayVideoResponseDTOError>;

export const PayVideoResponseDTO = union([
  PayVideoResponseDTOError,
  PayVideoResponseDTOSuccess,
]);

export type PayVideoResponseDTO = z.infer<typeof PayVideoResponseDTO>;
